// extracted by mini-css-extract-plugin
export default {"loginText":"styles_loginText__dbrBA","loginLink":"styles_loginLink__9GeUx"};